import React, { useEffect, useState } from 'react';
import { Button, Grid, makeStyles, TextField, Checkbox } from '@material-ui/core';
import Box from '@mui/material/Box';
import CloseIcon from '@material-ui/icons/Close';
import { useDispatch, useSelector } from 'react-redux';
import { Circle } from '@mui/icons-material';
import Theme from '../ui/Theme';
import Service from '../../apis/service';
import {
  showProgress,
  getPlanAssignedJourneys,
  getPlanList,
  getPlanDetails,
} from '../../redux/actions/DealershipActions';
import ShowProgress from '../ui/Backdrop';
import { ErrorToast, formateDate, notifySuccess } from '../utils/Utils';
import Modal from '../common/Modal';
import { apiEndpoints } from '../../constants/apiEndpoints';

const useStyles = makeStyles(() => ({
  journeyFrame: {
    width: '467px',
    height: '62px',
    left: '1px',
    top: '181px',
    background: '#FFFFFF',
  },
  journeyTitle: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '12px',
    lineHeight: '15px',
    color: '#000000',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  journeySubTitle: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '10px',
    lineHeight: '12px',
    marginTop: '2px',
    color: 'rgba(0, 0, 0, 0.4)',
    display: 'flex',
    flexDirection: 'row',
    gap: '5px',
    alignItems: 'center',
  },
  leftBarTitleText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '18px',
    lineHeight: '22px',
    display: 'flex',
    alignItems: 'center',
    color: '#000000',
  },
  leftBarTitleSubText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '18px',
    lineHeight: '22px',
    display: 'flex',
    alignItems: 'center',
    marginLeft: '2px',
    color: Theme.palette.primary.main,
  },
  leftPane: {
    width: '480px',
    height: '380px',
    overflowY: 'auto',
    '&::-webkit-scrollbar': { width: '8px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
    left: '319px',
    top: '182px',
    border: '1px solid #F4F4F4',
    marginTop: '16px',
  },
  leftPaneTitleFrame: {
    padding: '12px',
    border: '1px solid #F4F4F4',
  },
  popupHeading: {
    fontSize: '20px',
    fontWeight: '600',
    lineHeight: '22px',
    fontStyle: 'normal',
    marginBottom: '10px',
    marginTop: '0px',
    paddingLeft: '18px',
  },
  popSubmitBtn: {
    padding: '0 70px',
    height: '42px',
    width: '121px',
    marginRight: '23px',
  },
  popCancelBtn: {
    padding: '0 70px',
    height: '42px',
    width: '121px',
    marginRight: '28px',
  },
  popupCloseBtn: {
    borderRadius: '50%',
    backgroundColor: Theme.palette.secondary.main,
    padding: '8px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
    cursor: 'pointer',
  },
  planTitleBox: {
    width: '400px',
    height: '42px',
    background: '#FAFAFA',
  },
  planSearchFrame: {
    width: '320px',
    height: '42px',
    background: '#FAFAFA',
    border: '1px solid #F4F4F4',
    boxSizing: 'border-box',
  },
  planTitle: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '18px',
    paddingLeft: '14px',
    paddingTop: '10px',
    lineHeight: '24px',
    color: '#000000',
  },
  searchInputField: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '0px',
    color: '#000000',
    paddingLeft: '20px',
    paddingTop: '10px',
  },
}));
const PlanAddNewPopup = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const plandetails = useSelector((state) => state.getPlanDetails.plandetails);
  const journeylist = useSelector((state) => state.GetJourneyList.journeylist) || [];
  const planlist = useSelector((state) => state.GetPlanList.planlist);

  const [searchVal, setSearchVal] = React.useState('');
  const [title, setTitle] = React.useState('');
  const [checkAllAssigned, setCheckAllAssigned] = React.useState(false);
  const [checkAllUnassigned, setCheckAllUnassigned] = React.useState(false);
  const [assignedJourneys, setAssignedJourneys] = React.useState([]);
  const [assignedArr, setAssignedArr] = React.useState([]);
  const [unAssignedArr, setUnAssignedArr] = React.useState([]);
  const [unassignedJourneys, setUnassignedJourneys] = React.useState([]);
  const [filterAssignedArray, setFilterAssignedArray] = React.useState([]);
  const [filterUnassignedArray, setFilterUnassignedArray] = React.useState([]);
  const [assignedStories, setAssignedStories] = useState([]);
  const [unAssignedStories, setUnAssignedStories] = useState([]);
  const [allStories, setAllStories] = useState([]);
  const [assignedData, setAssignedData] = useState([]);
  const [unAssignedData, setUnAssignedData] = useState([]);
  const [filteredAssignedStory, setFilteredAssignedStory] = useState([]);
  const [filteredUnassignedStory, setFilteredUnassignedStory] = useState([]);
  const [selectedStoryAssign, setSelectedStoryAssign] = useState([]);
  const [selectedStoryUnassign, setSelectedStoryUnassign] = useState([]);

  const getJourneyPushOne = () => {
    const obj = [];
    const journeyPushTwo = (val, journey) => {
      if (val === journey.id.toString()) {
        obj.push({
          id: journey.id,
          title: journey.title,
          departmentRoles: [],
        });
      }
    };
    unAssignedArr.map((val) => journeylist.map((journey) => journeyPushTwo(val, journey)));
    obj.map((item) => dispatch(getPlanAssignedJourneys('assign', item)));
  };

  const handleSearchChange = (e) => {
    const input = e.target.value;
    setSearchVal(input);
    const assigned = props.type === 'Story' ? assignedStories : assignedJourneys;
    const unassigned = props.type === 'Story' ? unAssignedStories : unassignedJourneys;
    const filteredAssignedArray = input
      ? assigned?.filter((item) => item.title.toLowerCase().includes(input.toLowerCase()))
      : assigned;

    const filteredUnassignedArray = input
      ? unassigned?.filter((item) => item.title.toLowerCase().includes(input.toLowerCase()))
      : unassigned;

    if (props.type === 'Story') {
      setFilteredAssignedStory(filteredAssignedArray);
      setFilteredUnassignedStory(filteredUnassignedArray);
    } else {
      setFilterAssignedArray([...filteredAssignedArray]);
      setFilterUnassignedArray([...filteredUnassignedArray]);
    }
  };
  const updatePlanTitle = async (showSuccessMsg = true) => {
    const data = new global.FormData();
    data.append('title', title);
    await Service.put(apiEndpoints.PLAN_BY_ID.replace('ID', plandetails.id), data)
      .then((response) => {
        if (assignedArr?.length === 0 && unAssignedArr?.length === 0) {
          dispatch(showProgress(false));
          if (selectedStoryAssign?.length === 0 && selectedStoryUnassign?.length === 0)
            if (showSuccessMsg) {
              notifySuccess('Saved Successfully');
            }

          props.close();
        }
        const tempObj = {
          id: response.id,
          title: response.title,
        };
        dispatch(getPlanDetails(tempObj));
        dispatch(getPlanList('update_title', tempObj));
      })
      .catch((error) => {
        ErrorToast(error);
        if (assignedArr?.length === 0 && unAssignedArr?.length === 0) {
          dispatch(showProgress(false));
        }
      });
  };
  const assignWithCreate = async (unAssignedArrData, planId) => {
    await Service.post(apiEndpoints.PLAN_JOURNEY_ASSIGN.replace('PLAN_ID', planId), unAssignedArrData)
      .then(() => {
        dispatch(showProgress(false));
        getJourneyPushOne();
        const jobj = planlist.filter((val) => val.id === planId);
        dispatch(
          getPlanList('planJoruneyCount', {
            id: planId,
            len: parseInt(jobj[0].journeysCount, 10) + parseInt(unAssignedArr.length, 10),
          }),
        );
        notifySuccess('Saved Successfully');
        props.close();
      })
      .catch(() => {
        dispatch(showProgress(false));
        props.close();
      });
  };
  const addPlanTitle = async () => {
    const data = JSON.stringify({
      title,
    });

    await Service.post(apiEndpoints.GET_PLANS, data)
      .then((response) => {
        const tempObj = {
          id: response.id,
          title: response.title,
          journeysCount: unAssignedArr ? unAssignedArr.length : 0,
        };
        dispatch(getPlanList('update', tempObj));
        props.handleClick(0, response.id, tempObj);
        if (unAssignedArr.length > 0) {
          const planId = response.id;
          const unAssignedArrData = JSON.stringify({
            journeyIds: unAssignedArr,
          });
          assignWithCreate(unAssignedArrData, planId);
        } else {
          dispatch(showProgress(false));
          props.close();
        }
      })
      .catch((error) => {
        dispatch(showProgress(false));
        ErrorToast(error);
      });
  };
  const onClickAssignJourney = async () => {
    if (props.add === false) {
      updatePlanTitle();
      if (unAssignedArr.length > 0 && title) {
        dispatch(showProgress(true));
        const data = JSON.stringify({
          journeyIds: unAssignedArr,
        });
        await Service.post(apiEndpoints.PLAN_JOURNEY_ASSIGN.replace('PLAN_ID', plandetails?.id), data)
          .then(() => {
            dispatch(showProgress(false));
            getJourneyPushOne();
            const jobj = planlist.filter((val) => val.id === plandetails.id);
            dispatch(
              getPlanList('planJoruneyCount', {
                id: plandetails.id,
                len: parseInt(jobj[0].journeysCount, 10) + parseInt(unAssignedArr.length, 10),
              }),
            );
            notifySuccess('Saved Successfully');
            props.close();
          })
          .catch(() => {
            dispatch(showProgress(false));
            props.close();
          });
      }
    } else {
      addPlanTitle();
    }
  };
  const getPlans = async () => {
    dispatch(showProgress(true));

    try {
      const response = await Service.get(apiEndpoints.GET_PLANS, '');
      dispatch(getPlanList('fetch', response));
    } catch (error) {
      ErrorToast(error);
    }

    dispatch(showProgress(false));
  };
  const onClickUnassignJourney = async () => {
    updatePlanTitle();
    if (assignedArr.length > 0 && title) {
      dispatch(showProgress(true));
      const data = JSON.stringify({
        journeyIds: assignedArr,
      });
      await Service.post(apiEndpoints.PLAN_JOURNEY_UNASSIGN.replace('PLAN_ID', plandetails?.id), data)
        .then(() => {
          dispatch(showProgress(false));
          dispatch(getPlanAssignedJourneys('unassign', assignedArr));
          const jobj = planlist.filter((val) => val.id === plandetails.id);
          dispatch(
            getPlanList('planJoruneyCount', {
              id: plandetails.id,
              len: parseInt(jobj[0].journeysCount, 10) - parseInt(assignedArr.length, 10),
            }),
          );
          notifySuccess('Saved Successfully');
          props.close();
        })
        .catch(() => {
          dispatch(showProgress(false));
          props.close();
        });
    }
  };
  const handleOnChangeAssign = (event) => {
    if (checkAllAssigned) {
      setCheckAllAssigned(false);
    }
    if (props.type === 'Story') {
      const index = selectedStoryAssign?.indexOf(event.target.name);
      if (index > -1) {
        const tempArr = [...selectedStoryAssign];
        tempArr.splice(index, 1);
        setSelectedStoryAssign([...tempArr]);
      } else {
        const temp = [...selectedStoryAssign, event.target.name];
        setSelectedStoryAssign(temp);
        if (temp.length === assignedStories.length) {
          setCheckAllAssigned(true);
        }
      }
    } else {
      const index = assignedArr.indexOf(event.target.name);
      if (index > -1) {
        const tempArr = [...assignedArr];
        tempArr.splice(index, 1);
        setAssignedArr([...tempArr]);
      } else {
        setAssignedArr([...assignedArr, event.target.name]);
        const assignJArr = filterAssignedArray?.map((val) => val.id.toString());
        if (JSON.stringify(assignJArr.sort()) === JSON.stringify([...assignedArr, event.target.name].sort())) {
          setCheckAllAssigned(true);
        }
      }
      setUnAssignedArr([]);
    }
  };
  const handleOnChangeUnassign = (event) => {
    if (checkAllUnassigned) {
      setCheckAllUnassigned(false);
    }
    if (props.type === 'Story') {
      const index = selectedStoryUnassign?.indexOf(event.target.name);
      if (index > -1) {
        const tempArr = [...selectedStoryUnassign];
        tempArr.splice(index, 1);
        setSelectedStoryUnassign([...tempArr]);
      } else {
        const temp = [...selectedStoryUnassign, event.target.name];
        setSelectedStoryUnassign(temp);
        if (temp.length === unAssignedStories.length) {
          setCheckAllUnassigned(true);
        }
      }
    } else {
      const index = unAssignedArr?.indexOf(event.target.name);
      if (index > -1) {
        const tempArr = [...unAssignedArr];
        tempArr.splice(index, 1);
        setUnAssignedArr([...tempArr]);
      } else {
        setUnAssignedArr([...unAssignedArr, event.target.name]);
        const unassignJArr = unassignedJourneys?.map((val) => val.id.toString());
        if (JSON.stringify(unassignJArr.sort()) === JSON.stringify([...unAssignedArr, event.target.name].sort())) {
          setCheckAllUnassigned(true);
        }
      }
      setAssignedArr([]);
    }
  };
  const handleAllCheckedAssigned = () => {
    if (props.type === 'Story') {
      if (checkAllAssigned) {
        setCheckAllAssigned(false);
        setSelectedStoryAssign([]);
      } else {
        setCheckAllAssigned(true);
        const temp = assignedStories.map((i) => i.id.toString());
        setSelectedStoryAssign(temp || []);
      }
    } else {
      // eslint-disable-next-line no-lonely-if
      if (checkAllAssigned) {
        setCheckAllAssigned(false);
        setAssignedArr([]);
      } else {
        const tempArr = assignedArr;
        setCheckAllAssigned(true);
        filterAssignedArray?.map((val) => tempArr.push(val.id.toString()));
        setAssignedArr([...tempArr]);
      }
    }
  };
  const handleAllCheckedUnassigned = () => {
    if (props.type === 'Story') {
      if (checkAllUnassigned) {
        setCheckAllUnassigned(false);
        setSelectedStoryUnassign([]);
      } else {
        setCheckAllUnassigned(true);
        const temp = unAssignedStories.map((i) => i.id.toString());
        setSelectedStoryUnassign(temp || []);
      }
    } else {
      // eslint-disable-next-line no-lonely-if
      if (checkAllUnassigned) {
        setCheckAllUnassigned(false);
        setUnAssignedArr([]);
      } else {
        const tempArr = unAssignedArr;
        setCheckAllUnassigned(true);
        filterUnassignedArray?.map((val) => tempArr.push(val.id.toString()));
        setUnAssignedArr([...tempArr]);
      }
    }
  };

  const getButtonText = () => {
    if (props.type === 'Story') {
      if (selectedStoryAssign?.length > 0) {
        return 'Unassign';
      }
      if (selectedStoryUnassign?.length > 0) {
        return 'Assign';
      }
      return 'Save';
      // eslint-disable-next-line no-else-return
    } else {
      if (assignedArr?.length > 0) {
        return 'Unassign';
      }
      if (unAssignedArr?.length > 0) {
        return 'Assign';
      }
      return 'Save';
    }
  };

  const getJourneys = async (id) => {
    dispatch(showProgress(true));
    await Service.get(apiEndpoints.PLAN_JOURNEYS.replace('ID', id))
      .then((response) => {
        setAssignedJourneys([...response]);
        setFilterAssignedArray([...response]);
        const Users = journeylist.filter((itemA) => ![...response].find((itemB) => itemA.id === itemB.id));
        setUnassignedJourneys([...Users]);
        setFilterUnassignedArray([...Users]);
        dispatch(getPlanAssignedJourneys('fetch', [...response]));
        dispatch(showProgress(false));
      })
      .catch(() => {
        dispatch(showProgress(false));
      });
  };
  useEffect(() => {
    if (!props.add) {
      setTitle(plandetails?.title);
      if (plandetails?.id) {
        getJourneys(plandetails?.id);
      }
    } else {
      setUnassignedJourneys([...journeylist]);
      setFilterUnassignedArray([...journeylist]);
    }
  }, [plandetails]);

  const getAllStories = async () => {
    dispatch(showProgress(true));
    try {
      const res = await Service.get(apiEndpoints.GET_STORIES);
      setAllStories(res || []);
    } catch (error) {
      ErrorToast(error);
    }

    dispatch(showProgress(false));
  };
  useEffect(() => {
    getAllStories();
  }, []);

  const getAssignedStories = async (id) => {
    dispatch(showProgress(true));
    try {
      const res = await Service.get(apiEndpoints.PLAN_STORY.replace('ID', id));
      setAssignedStories(res || []);
    } catch (error) {
      ErrorToast(error);
    }

    dispatch(showProgress(false));
  };

  useEffect(() => {
    if (plandetails?.id) {
      getAssignedStories(plandetails?.id);
    }
  }, [plandetails]);

  const getUnAssignedStories = (total, assigned) => {
    const assignedIds = new Set(assigned.map((i) => i.id) || []);
    const unAssigned = total.filter((i) => !assignedIds.has(i.id));
    setUnAssignedStories(unAssigned || []);
  };

  useEffect(() => {
    getUnAssignedStories(allStories, assignedStories);
  }, [assignedStories, allStories]);

  useEffect(() => {
    if (props.type === 'Story') {
      setAssignedData(filteredAssignedStory);
    } else {
      setAssignedData(filterAssignedArray);
    }
  }, [filterAssignedArray, filteredAssignedStory]);

  useEffect(() => {
    if (props.type === 'Story') {
      setUnAssignedData(filteredUnassignedStory);
    } else {
      setUnAssignedData(filterUnassignedArray);
    }
  }, [filterUnassignedArray, filteredUnassignedStory]);

  useEffect(() => {
    setFilteredAssignedStory(assignedStories);
  }, [assignedStories]);

  useEffect(() => {
    setFilteredUnassignedStory(unAssignedStories);
  }, [unAssignedStories]);

  const onAssignStory = async () => {
    dispatch(showProgress(true));
    try {
      await Service.post(apiEndpoints.PLAN_STORY_ASSIGN.replace('ID', plandetails?.id), {
        storyIds: selectedStoryUnassign,
      });
      getPlans();
      notifySuccess('Saved Successfully');
      props.close();
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  const onUnassignStory = async () => {
    dispatch(showProgress(true));
    try {
      await Service.post(apiEndpoints.PLAN_STORY_UNASSIGN.replace('ID', plandetails?.id), {
        storyIds: selectedStoryAssign,
      });
      getPlans();
      notifySuccess('Saved Successfully');
      props.close();
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  const handleSubmit = () => {
    if (props.type === 'Story') {
      if (selectedStoryAssign?.length > 0) {
        updatePlanTitle(false);
        onUnassignStory();
      }
      if (selectedStoryUnassign?.length > 0) {
        updatePlanTitle(false);
        onAssignStory();
      }
      if (selectedStoryAssign?.length === 0 && selectedStoryUnassign?.length === 0) {
        updatePlanTitle();
      }
    } else {
      // eslint-disable-next-line no-lonely-if
      if (assignedArr?.length > 0) {
        onClickUnassignJourney();
      } else {
        onClickAssignJourney();
      }
    }
  };

  return (
    <Modal isOpen={props.open} height="606px" width="961px">
      <div>
        <Grid container direction="column">
          <Grid item>
            <Grid direction="row" container alignItems="center">
              <Grid item xs={11}>
                <p className={classes.popupHeading}>{props.add ? `Add ${props.type}` : `Edit ${props.type}`}</p>
              </Grid>
              <Grid item xs={1}>
                <CloseIcon className={classes.popupCloseBtn} onClick={props.close} />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              style={{ marginTop: '16px', padding: '10px' }}
            >
              <Grid item className={classes.planTitleBox}>
                <TextField
                  id="planTitleId"
                  name="planTitle"
                  required
                  autoFocus
                  autoComplete="off"
                  width="100%"
                  autoSave="off"
                  placeholder="Enter plan title here"
                  InputProps={{
                    disableUnderline: true,
                    classes: {
                      input: classes.planTitle,
                    },
                  }}
                  value={title}
                  rows={1}
                  onChange={(e) => {
                    setTitle(e.target.value);
                  }}
                />
              </Grid>
              <Box sx={{ width: 1 / 20 }}></Box>
              <Grid item className={classes.planSearchFrame}>
                <TextField
                  id="searchId"
                  name="searchText"
                  required
                  autoFocus
                  autoComplete="off"
                  width="100%"
                  autoSave="off"
                  placeholder={`Search for ${props.type}`}
                  InputProps={{
                    disableUnderline: true,
                    classes: {
                      input: classes.searchInputField,
                    },
                  }}
                  onChange={handleSearchChange}
                  value={searchVal}
                  rows={1}
                />
              </Grid>
            </Grid>
            <Grid container direction="row">
              <Grid item xs={6}>
                <Grid container direction="column" className={classes.leftPane}>
                  <Grid item>
                    <Grid container direction="row" className={classes.leftPaneTitleFrame}>
                      <Grid item className={classes.leftBarTitleText}>
                        {`Assigned ${props.type}`}
                      </Grid>
                      <Grid item className={classes.leftBarTitleSubText}>
                        {assignedData ? ` (${assignedData?.length})` : ' (0)'}
                      </Grid>
                    </Grid>
                    <Grid container direction="row" alignItems="center" className={classes.journeyFrame}>
                      <Grid item>
                        <Checkbox
                          key="select_all_assign"
                          disabled={
                            props.type === 'Story' ? selectedStoryUnassign?.length > 0 : unAssignedArr?.length > 0
                          }
                          checked={checkAllAssigned}
                          onClick={handleAllCheckedAssigned}
                        />
                      </Grid>
                      <Grid item className={classes.journeyTitle}>
                        Select All
                      </Grid>
                    </Grid>
                    {assignedData?.map((val) => (
                      <Grid container direction="row" alignItems="center" className={classes.journeyFrame}>
                        <Grid item>
                          <Checkbox
                            key="assign_key"
                            name={val.id}
                            value={val.title}
                            onChange={handleOnChangeAssign}
                            checked={
                              props.type === 'Story'
                                ? selectedStoryAssign?.includes(val.id.toString())
                                : assignedArr?.indexOf(val.id.toString()) > -1
                            }
                            disabled={
                              props.type === 'Story' ? selectedStoryUnassign?.length > 0 : unAssignedArr?.length > 0
                            }
                          />
                        </Grid>
                        <Grid item>
                          <Grid container direction="column" alignItems="start" style={{ width: '300px' }}>
                            <Grid item className={classes.journeyTitle}>
                              {val.title}
                            </Grid>
                            {props.type === 'Story' && (
                              <Grid item className={classes.journeySubTitle}>
                                {formateDate(val.publish_date)} <Circle style={{ fontSize: '6px' }} /> {val.instructor}
                              </Grid>
                            )}
                          </Grid>
                        </Grid>
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={6}>
                <Grid container direction="column" className={classes.leftPane}>
                  <Grid item>
                    <Grid container direction="row" className={classes.leftPaneTitleFrame}>
                      <Grid item className={classes.leftBarTitleText}>
                        {`Unassigned ${props.type} `}
                      </Grid>
                      <Grid item className={classes.leftBarTitleSubText}>
                        {unAssignedData ? ` (${unAssignedData.length})` : ' (0)'}
                      </Grid>
                    </Grid>
                    <Grid container direction="row" alignItems="center" className={classes.journeyFrame}>
                      <Grid item>
                        <Checkbox
                          key="select_all_unassign"
                          disabled={props.type === 'Story' ? selectedStoryAssign?.length > 0 : assignedArr?.length > 0}
                          checked={checkAllUnassigned}
                          onClick={handleAllCheckedUnassigned}
                        />
                      </Grid>
                      <Grid item className={classes.journeyTitle}>
                        Select All
                      </Grid>
                    </Grid>
                    {unAssignedData.map((val) => (
                      <Grid container direction="row" alignItems="center" className={classes.journeyFrame}>
                        <Grid item>
                          <Checkbox
                            key="unassign_key"
                            name={val.id}
                            value={val.title}
                            disabled={
                              props.type === 'Story' ? selectedStoryAssign?.length > 0 : assignedArr?.length > 0
                            }
                            checked={
                              props.type === 'Story'
                                ? selectedStoryUnassign?.includes(val.id.toString())
                                : unAssignedArr?.indexOf(val.id.toString()) > -1
                            }
                            onChange={handleOnChangeUnassign}
                          />
                        </Grid>
                        <Grid item>
                          <Grid container direction="column" alignItems="start" style={{ width: '300px' }}>
                            <Grid item className={classes.journeyTitle}>
                              {val.title}
                            </Grid>
                            {props.type === 'Story' && (
                              <Grid item className={classes.journeySubTitle}>
                                {formateDate(val.publish_date)} <Circle style={{ fontSize: '6px' }} /> {val.instructor}
                              </Grid>
                            )}
                          </Grid>
                        </Grid>
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid container justifyContent="flex-end" style={{ marginTop: '24px' }}>
              <Button variant="contained" className={classes.popCancelBtn} onClick={props.close}>
                Cancel
              </Button>
              <Button variant="contained" color="primary" className={classes.popSubmitBtn} onClick={handleSubmit}>
                {getButtonText()}
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <ShowProgress />
      </div>
    </Modal>
  );
};

export default PlanAddNewPopup;
